export const FEATURES = {
  CHAMPION_PASSPORT: "champion_passport",
  SELF_ASSESSMENTS: "self_assessments",
  CUSTOM_ACTIVITY_ACTIONS_AND_OBJECTS: "custom_actions_and_objects",
} as const;
